import { Link } from 'react-router-dom';
import { articleData } from '@/mocks/articles';

export default function BlogSection() {
  const blogArticles = articleData.filter(a => a.slug !== 'cssbuy-spreadsheet');

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-12">
        <div className="mb-14">
          <p className="font-heading italic text-sm text-foreground-500 mb-2">
            Blog & Guias
          </p>
          <h2 className="font-heading text-4xl md:text-5xl text-foreground-900 leading-tight">
            Guias Completos
            <br />
            <span className="font-heading italic text-primary-500">
              para CSSBuy em Português
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.01] border border-background-200/60"
            >
              <div className="h-[220px] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    Junho 2026
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 font-semibold leading-snug mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-3 text-sm font-medium text-primary-500">
                  Ler Artigo
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}